import { Component, Input, OnInit } from '@angular/core';
import { Employee } from "../../core/models/employee.model";

@Component({
    selector: 'app-reference-show',
    templateUrl: './reference-show.component.html',
    styleUrls: ['./reference-show.component.css']
})
export class ReferenceShowComponent implements OnInit {

    @Input()
    employee: Employee;

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/verification-show/reference-show/reference-show.component.ts